import {t} from '@lingui/core/macro';
import {PALETTE} from 'shared/config/model/palette';

export type MonitorStatus = 'active' | 'paused' | 'unsubscribed';

export const translateMonitorStatus = (status: MonitorStatus): string => {
    const map = {
        active: t`Активен`,
        paused: t`На паузе`,
        unsubscribed: t`Отписка`,
    };

    return map[status];
};

export const colorMonitorStatus = (status: MonitorStatus): string => {
    const map = {
        active: PALETTE.success,
        paused: PALETTE.neutralMuted,
        unsubscribed: PALETTE.error,
    };

    return map[status];
};
